import { useOne } from "@/hooks/useResourceOne";
import { useBasicComponents } from "../useBasicComponent";
import { useResourceUpdate } from "@/hooks/useResourceUpdate";

export const usePoolMySqlConfig = (id) => {
  const { mutateAsync, isLoading: isSaving } = useResourceUpdate();
  const { data, isLoading, isError } = useOne({
    skip: !id,
    meta: {
      op: 'mysql',
    },
  });
  const { replicasReadOnly, core, memory, version, dataDisk, poolSize } = useBasicComponents();

  return {
    isLoading,
    isSaving,
    save: async (data) => {
      if (!id || !data) return;
      return await mutateAsync({ values: data });
    },
    value: (isLoading || isError) ? {} : { mysql: data?.mysql },
    schema: [
      {
        type: 'array',
        title: "",
        dataIndex: "mysql",
        colProps: { span: 24, xs: 24, sm: 24, md: 24 },
        fields: [
          [
            replicasReadOnly({
              dataIndex: 'replicas',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            core({
              dataIndex: 'core',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            memory({
              dataIndex: 'memory',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            version({
              dataIndex: 'version',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            {
              valueType: 'dependency',
              name: ['name'],
              columns: ({ name }) => {
                if (name === 'mysql' || name === 'mysql-console') {
                  return [dataDisk({
                    dataIndex: 'dataDisk',
                    width: 'sm',
                    colProps: { xs: 24, sm:8 },
                  })];
                } else {
                  return [];
                }
              }
            },
            {
              valueType: 'dependency',
              name: ['name'],
              columns: ({ name }) => {
                if (name === 'mysql') {
                  return [poolSize({
                    dataIndex: 'poolSize',
                    width: 'sm',
                    colProps: { xs: 24, sm:8 },
                  })];
                } else {
                  return [];
                }
              }
            },
          ],
        ],
      },
    ],
  };
};